import styled from "styled-components";

type TextType = {
    color: string;
}

export const ContentInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 30px;
  min-height: 30px;
`;

export const Title = styled.span<TextType>`
    font-size: 14px;
    color: ${props => props.color};
    font-weight: bold;
`;

export const Description = styled.span<TextType>`
    font-size: 14px;
    color: ${props => props.color};
`;